/**
 * DATALAYER
 */

$.fn.pushDatalayer = function(data, ecommerce = false) {
    window.dataLayer = window.dataLayer || [];

    if (ecommerce) {
        window.dataLayer.push({ ecommerce: null });
    }

    window.dataLayer.push(data);
}
